import { useState, useEffect } from 'react'
import { authHeaders } from '../utils/authFetch'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'

export function useBranchAIHistory(branchId) {
    const [history, setHistory] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchHistory = async () => {
        if (!branchId) return
        setLoading(true)
        try {
            const res = await fetch(`${BASE_URL}/api/ai-history?branchId=${branchId}`, {
                headers: authHeaders(),
            })
            const data = await res.json()
            if (res.ok) setHistory(data ?? [])
        } catch (err) {
            console.error('Error fetching branch AI history:', err)
        }
        setLoading(false)
    }

    const saveAnalysis = async ({ summary, recommendations, branchName, dateRange, startISO, endISO }) => {
        try {
            const res = await fetch(`${BASE_URL}/api/ai-history`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({ summary, recommendations, branchName, branchId, dateRange, startISO, endISO }),
            })
            const data = await res.json()
            if (!res.ok) return { data: null, error: new Error(data.error || 'Failed to save') }
            setHistory(prev => [data, ...prev])
            return { data, error: null }
        } catch (err) {
            return { data: null, error: err }
        }
    }

    const deleteAnalysis = async (id) => {
        try {
            const res = await fetch(`${BASE_URL}/api/ai-history/${id}`, {
                method: 'DELETE',
                headers: authHeaders(),
            })
            if (!res.ok) return { error: new Error('Failed to delete') }
            setHistory(prev => prev.filter(h => h.id !== id))
            return { error: null }
        } catch (err) {
            return { error: err }
        }
    }

    useEffect(() => {
        fetchHistory()
    }, [branchId])

    return { history, loading, saveAnalysis, deleteAnalysis, fetchHistory }
}